import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CaseCounts, AccountCenterListRecordView } from '../../types/Types';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProcessPostService {
  constructor(protected http: HttpClient) {}

  public fetchRecordsPaginated(
    pageNumberStart: number,
    recordsPerPage: number
  ): Promise<Array<AccountCenterListRecordView>> {
    return this.http
      .post('/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&cases=true', {
        pageNumberStart,
        recordsPerPage,
      })
      .toPromise()
      .then((res) => {
        const dateKeys = [
          'lastUpdatedDate',
          'applicationSignedDate',
          'effectiveDate',
          'freeLookEndDate',
          'issuePolicyRequestDate',
          'nextPaymentDate',
          'tlicEffectiveDate',
          'policyCreatedTime',
        ];
        const resString = JSON.stringify(res);
        const parsedRes = JSON.parse(resString, (key, value) => {
          return dateKeys.includes(key) && value ? new Date(value) : value;
        });
        return parsedRes.cases as Array<AccountCenterListRecordView>;
      });
  }

  public fetchRecordsPaginated$(
    pageNumberStart: number,
    recordsPerPage: number
  ): Observable<Array<AccountCenterListRecordView>> {
    return this.http
      .post('/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&cases=true', {
        pageNumberStart,
        recordsPerPage,
      })
      .pipe(
        map((res) => {
          const dateKeys = [
            'lastUpdatedDate',
            'applicationSignedDate',
            'effectiveDate',
            'freeLookEndDate',
            'issuePolicyRequestDate',
            'nextPaymentDate',
            'tlicEffectiveDate',
            'policyCreatedTime',
          ];
          const resString = JSON.stringify(res);
          const parsedRes = JSON.parse(resString, (key, value) => {
            return dateKeys.includes(key) && value ? new Date(value) : value;
          });
          return parsedRes.cases as Array<AccountCenterListRecordView>;
        })
      );
  }

  public fetchCaseCounts(): Promise<CaseCounts> {
    return this.http
      .post<{ counts: CaseCounts }>(
        '/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&counts=true',
        {}
      )
      .toPromise()
      .then((res) => res.counts);
  }

  public fetchCaseCounts$(): Observable<CaseCounts> {
    return this.http
      .post<{ counts: CaseCounts }>(
        '/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&counts=true',
        {}
      )
      .pipe(map((res) => res.counts));
  }

  public fetchListViewCaseCount(): Promise<number> {
    return this.http
      .post<{ totalCount: number }>(
        '/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&totalCount=true',
        {}
      )
      .toPromise()
      .then((res) => Number(res.totalCount));
  }

  public fetchListViewCaseCount$(): Observable<number> {
    return this.http
      .post<{ totalCount: number }>(
        '/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&totalCount=true',
        {}
      )
      .pipe(map((res) => Number(res.totalCount)));
  }

  public submittedAppsCounts(): Promise<{ submittedAppsPrimary: number; submittedAppsNotPrimary: number }> {
    return this.http
      .post<{ submittedAppsPrimary: number; submittedAppsNotPrimary: number }>(
        '/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&submittedAppsCounts=true',
        {}
      )
      .pipe(
        map(({ submittedAppsPrimary, submittedAppsNotPrimary }) => ({ submittedAppsPrimary, submittedAppsNotPrimary }))
      )
      .toPromise();
  }

  async downloadStatus() {
    const status = await this.http
      .post<{ fileReady: boolean; downloadFailed: boolean }>(
        '/amorphic/xhr?path=coverpath-agent&form=true&fromAccountCenter=true&downloadStatus=true',
        {}
      )
      .toPromise();
    return status;
  }
}
